import { connect, MapStateToProps } from 'react-redux';
import { Props } from './ThreadHeader';
import { getThreadState } from '../../selectors';

export type StateProps = Pick<Props, 'total'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableItemId, commentableTypeId, parentId }
) => {
  const { total } = getThreadState(state, commentableTypeId, commentableItemId, parentId);

  return { total };
};

export default connect(mapStateToProps);
